import { createFileRoute } from '@tanstack/react-router';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';
import { z } from 'zod';
import { ScheduledDowntimePage } from '@/components/ScheduledDowntimePage';

const downtimeSearchSchema = z.object({
  tenantId: z.string().optional(),
});

export const Route = createFileRoute('/downtime')({
  component: Downtime,
  validateSearch: zodSearchValidator(downtimeSearchSchema),
});

function Downtime() {
  const { tenantId } = Route.useSearch();

  return <ScheduledDowntimePage tenantId={tenantId} />;
}
